<div class="modal-header">
    <h4 class="modal-title">{{ 'Attachments' | translate }}</h4>
    <button class="close" type="button" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    @if (isPcsMode) {
        <div class="row">
            <div class="col">
                <kendo-grid [data]="pcsAttachments">
                    <kendo-grid-column title="{{ 'Attachment Name' | translate }}" field="attachmentName">
                        <ng-template kendoGridCellTemplate let-row>
                            <span class="attachmentLink" (click)="attachmentDownload(row.attachmentId)">
                                {{ row.attachmentName }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Description' | translate }}"
                        field="attachmentDescription"></kendo-grid-column>
                    <kendo-grid-column title="{{ 'Created On Status' | translate }}" [width]="120">
                        <ng-template kendoGridCellTemplate let-row>
                            {{ row.createdOnStatus.localizedCode + '-' + row.createdOnStatus.name }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="{{ 'Created By' | translate }}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{ row.createdBy.firstName + ' ' + row.createdBy.lastName }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="{{ 'Created Date' | translate }}">
                        <ng-template kendoGridCellTemplate let-row>
                            <span>{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Remove' | translate }}"
                        [width]="100"
                        [style]="{ 'text-align': 'center' }">
                        <ng-template kendoGridCellTemplate let-row>
                            <button
                                class="btn btn-sm btn-danger"
                                [disabled]="
                                    pcsDocumentAndApprovalStatusId !== row.createdOnStatus.id ||
                                    !belongsToOrganization(row.organizationOfCreatedBy)
                                "
                                (click)="openRemoveAttachmentDialog(row.id)">
                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            </button>
                        </ng-template>
                    </kendo-grid-column>
                    <ng-template kendoGridNoRecordsTemplate>
                        <p>{{ 'No records available' | translate }}.</p>
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
    }

    @if (!isPcsMode && attachments?.length > 0) {
        <div class="row">
            <div class="col">
                <kendo-grid [data]="attachments">
                    <kendo-grid-column title="{{ 'Attachment Name' | translate }}" field="name">
                        <ng-template kendoGridCellTemplate let-row>
                            <span class="attachmentLink" (click)="downloadAttachment(row.attachedFile)">
                                {{ row.name }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="{{ 'Description' | translate }}" field="description"></kendo-grid-column>
                    <kendo-grid-column
                        title="{{ 'Remove' | translate }}"
                        [width]="100"
                        [style]="{ 'text-align': 'center' }">
                        <ng-template kendoGridCellTemplate let-row>
                            <button
                                class="btn btn-sm btn-danger"
                                [disabled]="!row.canRemove"
                                (click)="openRemoveAttachmentDialog(row.id)">
                                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                            </button>
                        </ng-template>
                    </kendo-grid-column>
                    <ng-template kendoGridNoRecordsTemplate>
                        <p>{{ 'No records available' | translate }}.</p>
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
    }
</div>

@if (removeAttachmentDialog) {
    <kendo-dialog
        title="{{ 'Remove Attachment' | translate }}"
        [minWidth]="350"
        (close)="closeRemoveAttachmentDialog()">
        <div class="row">
            <span>{{ 'Are you sure you want to remove this attachment?' | translate }}</span>
        </div>
        <kendo-dialog-actions layout="end">
            <button class="btn btn-sm btn-primary" kendoButton (click)="submitRemoveAttachment()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Submit' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeRemoveAttachmentDialog()">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}
